module.exports = __webpack_public_path__ + "static/img/sm4.dd581a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm4.jpg
// module id = /7bu
// module chunks = 1